import { ConfigExample } from './index';

/**
 * An example Ergogen configuration for the Atreus keyboard.
 * This is a simplified version focusing on the points definition.
 * @type {ConfigExample}
 */
const Atreus: ConfigExample = {
  label: 'Atreus (simplified)',
  author: 'MrZealot',
  value: `points:
  zones:
    matrix:
      columns:
        pinky:
        ring:
          key.stagger: 3
        middle:
          key.stagger: 5
        index:
          key.stagger: -5
        inner:
          key.stagger: -6
        thumb:
          key.skip: true
          key.stagger: 10
          rows:
            home.skip: false
      rows:
        bottom:
        home:
        top:
        num:
  rotate: -10
  mirror:
    ref: matrix_thumb_home
    distance: 22
`,
};

export default Atreus;
